import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ServiceCard = ({ title, description, details, icon }) => {
    const [isExpanded, setIsExpanded] = useState(false);
  
    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };
  
    return (
      <div
        onClick={toggleExpand}
        className={`bg-white border border-gray-100 shadow-lg rounded-md p-8 text-center transition-transform transform hover:scale-105 cursor-pointer ${
          isExpanded ? 'shadow-2xl' : ''
        }`}
      >
        <div className="mb-4 text-blue-600">
          <FontAwesomeIcon icon={icon} size="3x" />
        </div>
        <h3 className="text-xl font-bold mb-4">{title}</h3>
        <p className="text-gray-600">{isExpanded ? details : description}</p>
        {isExpanded && (
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevent click from collapsing the card again
              setIsExpanded(false);
            }}
            className="mt-4 text-blue-600 underline"
          >
            Collapse
          </button>
        )}
      </div>
    );
  };  

export default ServiceCard;
